import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Loading from '../loading/Loading'
import Swal from 'sweetalert2';
import axios from 'axios';
import MyModal from '../modal/MyModal'
import { format } from 'date-fns';
import {
  Typography, TablePagination,
  Table, TableBody, TableCell,
  TableHead, TableRow, TableContainer,
} from "@mui/material";


function AdvertisementList({ garagesList, actions }) {
  const navigate = useNavigate();
  const [garagesLists, setGaragesList] = useState(garagesList)
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading Advertisement, Please Wait...')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [filteredGarages, setFilteredGarages] = useState([]);
  const [test, setTest] = useState(false);

  const showTime = format(new Date(), 'MMddyyyyHis');


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    const filtered = garagesLists.filter((garage) => {
      const searchValue = searchInput.toLowerCase();
      const searchProperties = [
        garage.lastname, garage.businessName,
        garage.businessLicense, garage.email,
        garage.phoneNumber, garage.businessURL,
        garage.ZipCodes, garage.PaymentType,
        garage.startDate, garage.endDate,
      ];
      return searchProperties.some((property) => {
        if (typeof property === 'string' && property.toLowerCase().includes(searchValue)) {
          return true;
        } else if (typeof property === 'number' && property.toString().includes(searchValue)) {
          return true;
        }
        return false;
      });
    });

    setFilteredGarages(filtered);
  };

  useEffect(() => {
    if (garagesLists && Object.keys(garagesLists).length) {
      const getGaragesComponents = (garage, element) => {
        // console.log(garage)
      };

      async function getGarages(garagesLists) {
        let garagesContainer = [];
        try {
          for (const garage in garagesLists) {
            const element = garagesLists[garage];
            garagesContainer.push(getGaragesComponents(garage, element));
          }
          return garagesContainer;
        } catch (error) {
          throw error;
        }
      }

      getGarages(garagesLists).then(resp => {
        if (resp.length > 0) {
          setLoading(false);
        } else {
          setLoading(true);
          setLoadingText("Oops, no garages found");
        }
      });
    } else {
      setLoading(() => false);
    }
  }, [garagesLists, actions, test])

  function approveFun(key, ToggleValue) {
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${ToggleValue ? 'Disable' : 'Enable'} this Advertisement!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes, ${ToggleValue ? 'Disable' : 'Enable'} it!`
    }).then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: 'Updating, please wait',
          html:
              '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
          showConfirmButton: false,
          showCancelButton: false,
          focusConfirm: false,
      });
        axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateUserStatus', userStatus: !ToggleValue, id: key })
          .then(response => {
            Swal.fire(
              'success',
              response.data.message,
              'success'
            ).then(() => {
              window.location.reload();
            })
          })
          .catch(error => {
            Swal.fire(
              'There were a problem',
              error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
              'error'
            )
            console.error('Error fetching data:', error);
          });

        // axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateUserStatus', userStatus: !ToggleValue, id: key })
        //   .then(response => {
        //     // Update the garagesList state with the updated data
        //     const updatedGaragesList = garagesList.map(garage => {
        //       if (garage.id === key) {
        //         // Toggle the userStatus value
        //         return {
        //           ...garage,
        //           userStatus: !ToggleValue ? 1 : 0 // Assuming userStatus is 0 or 1
        //         };
        //       } else {
        //         return garage;
        //       }
        //     });
        //     setGaragesList(updatedGaragesList); // Update the state
        //     // Display success message
        //     Swal.fire(
        //       'success',
        //       response.data.message,
        //       'success'
        //     ).then(
        //       navigate(0)
        //     )
        //     setTest(!test); // Trigger re-render
        //   })
        //   .catch(error => {
        //     // Handle error
        //     Swal.fire(
        //       'There were a problem',
        //       error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
        //       'error'
        //     );
        //     console.error('Error fetching data:', error);
        //   });

      } else {
        // setGaragesopen((prevGarages) =>
        //   prevGarages.map((garage) =>
        //     garage.id === key ? { ...garage, userStatus: originalUserStatus } : garage
        //   )
        // );
      }
    })
  }

  function handleShow(addPaymentObject, payment) {
    axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, {
      datebaseid: addPaymentObject,
      // amount: payment,
      // description: 'Pay for Addvertisement',
      // type: 'new'
      action: "adAddPayment"
    })
      .then((response22) => {
        localStorage.setItem('add_payment', JSON.stringify(response22.data.datebaseid));
        localStorage.setItem('orderId', JSON.stringify(response22.data.order_id));
        navigate('/payment');

      })
      .catch((error) => {
        console.error('Error fetching client secret:', error);
      });
  }

  return (loading ?
    <Loading text={loadingText} />
    :
    <>
      <div className="col-md-12 d-flex">
        <input
          className='form-control w-25 mx-2 py-2'
          type="text"
          placeholder="Search Advertisement"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <button onClick={handleSearch} className='btn btn-outline-success  py-2'>Search</button>
      </div>
      <TableContainer
        className='table'
        sx={{
          width: {
            xs: "274px",
            sm: "100%",
          },
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            whiteSpace: "nowrap",
            mt: 2,
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Image</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Business Name</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">ZipCode</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Payment Type</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Date</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Admin Status</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Status</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">View</Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6"></Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Edit</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {garagesLists.map((element, index) => (
              <TableRow key={index}>
                <TableCell className="image-ads">
                  <img width={200}
                    className="garage__image"
                    src={`${element.picture ? `${process.env.REACT_APP_UPLOAD_URL + element.picture}?time=${showTime}` : `${process.env.REACT_APP_UPLOAD_URL + 'images/images.png'}`}`}
                    alt='imagesURL'
                    style={{ transform: `rotate(${element.pictureA ? element.pictureA : 0}deg)` }}
                  />
                </TableCell>

                <TableCell>
                  <Typography color="textSecondary" variant="h6">{element.businessName ? element.businessName : ''}</Typography>
                </TableCell>

                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {element.ZipCodes.map((item, index) => (
                      (item !== "" &&
                        <div key={index}>
                          <p>{item}</p>
                        </div>
                      )
                    ))}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography color="textSecondary" variant="h6">{element.PaymentType === 'YearlyBilling' ? 'Annual' : 'Monthly'}</Typography>
                </TableCell>

                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {element.startDate !== '0000-00-00 00:00:00' ? format(new Date(element.startDate), 'MM/dd/yyyy') : ''}

                    {element.endDate === '0000-00-00 00:00:00' ?
                      '' :
                      `- ${element.endDate !== '0000-00-00 00:00:00' ? format(new Date(element.endDate), 'MM/dd/yyyy') : ''}`
                    }
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">{element.approveStatus === 1 ? 'Approved' : ''}</Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {element.approveStatus === 0 || element.approveStatus === 2 ? (
                      <div>
                        {element.PaymentStatus === 0 ? 'Payment Pending' : element.approveStatus === 0 ? 'Approval pending' : element.approveStatus === 2 ? 'Disabled by Admin' : ''}
                        <br />
                      </div>
                    ) : (
                      <>
                        <button
                          style={{ background: "green", color: "white", border: "none", padding: "3px 5px", borderRadius: "5px" }}
                          onClick={() => approveFun(element.id, element.userStatus === 1 ? true : false)} >
                          {element.userStatus === 1 ? "Enabled" : "Disabled"}
                        </button>
                      </>
                    )}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    <MyModal elements={element} />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    
                    {element.PaymentStatus === 0 && element.type === 'new' ? (
                      <Button variant="primary" onClick={() => handleShow(element.id, element.TotalPay)}>Pay Now</Button>
                    ) :
                    element.renewButton===true ?
                      element.futurePayment === 1 ? '' : <Link to={`/RenewAddvertisement/${element.id}`}>
                          <Button variant="primary">Renew</Button>
                        </Link>
                        : ''
                    }



                    {/* {((element.endDate === '0000-00-00 00:00:00') || element.PaymentStatus == 0) ? (
                      <Link className='btn btn-primary' variant="primary" onClick={() => CreatePaymentIntent(element.id, element.TotalPay)}>
                        Renew
                      </Link>
                    ) : `Last date: ${element.endDate !== '0000-00-00 00:00:00' ? format(new Date(element.endDate), 'MM/dd/yyyy') : ''}`
                    } */}

                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">

                    {element.approveStatus === 0 || (element.today > element.endDate) ?
                      ''
                      :
                      <Link to={`/advertisement-edit/${element.id}`}><i className='fa fa-pencil'></i></Link>
                    }

                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer >
      <TablePagination
        component="div"
        count={garagesList.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  )
}

export default AdvertisementList;
